<template>
  <div style="display: flex; flex-direction: row; align-items: center; gap: 20px;">
    <span>A/B tests:</span>
    <span v-for="(experiment, key) in $abtest.experimentsRef.value" :key="key">
      <label>{{ key }}:</label>
      <select v-model="experiment.choice" @change="$abtest.saveExperiment(key, ($event.target as HTMLSelectElement).value)">
        <option v-for="variant in experiment.variants" :key="variant" :value="variant">
          {{ variant }}
        </option>
      </select>
    </span>
  </div>
</template>

<script setup lang="ts">
const { $abtest } = useNuxtApp()
</script>
